export const DIGESTION_QUESTIONS = {
    safety: {
        id: 'safety',
        number: 1,
        text: 'First, let\'s confirm, do you currently have any of the following conditions?',
        hint: 'For your health and safety, we need to know these first',
        type: 'checkbox',
        options: [
            { value: 'pregnant', label: '🤰 Pregnant or breastfeeding' },
            { value: 'ulcer', label: '🩺 Have gastric or duodenal ulcers' },
            { value: 'liver_kidney', label: '❤️ Have severe liver or kidney disease' },
            { value: 'medication', label: '💊 Taking digestive medications (e.g., proton pump inhibitors)' },
            { value: 'none', label: '✓ None of the above, continue', exclusive: true }
        ]
    },

    demographics: {
        id: 'demographics',
        number: 2,
        text: 'Tell us some basic information',
        type: 'multi-part',
        parts: [
            {
                id: 'age',
                label: 'Age Group',
                type: 'radio',
                options: [
                    { value: '18-35', label: '18-35 years' },
                    { value: '36-50', label: '36-50 years' },
                    { value: '51-65', label: '51-65 years' },
                    { value: 'other', label: 'Other age group' }
                ]
            },
            {
                id: 'weight',
                label: 'Weight',
                type: 'radio',
                options: [
                    { value: '<50', label: '< 110 lbs (< 50 kg)' },
                    { value: '50-70', label: '110-154 lbs (50-70 kg)' },
                    { value: '70-90', label: '155-200 lbs (70-90 kg)' },
                    { value: '>90', label: '> 200 lbs (> 90 kg)' }
                ]
            }
        ]
    },

    mainIssue: {
        id: 'mainIssue',
        number: 3,
        text: 'What is your main digestive issue?',
        hint: 'You can select 1-2 that bother you the most',
        type: 'checkbox',
        maxSelect: 2,
        options: [
            { value: 'bloating', label: '🎈 Prone to bloating, stomach feels bloated after eating' },
            { value: 'poor_appetite', label: '🍽️ Poor appetite, do not want to eat' },
            { value: 'indigestion', label: '😫 Indigestion, food sits in stomach' },
            { value: 'bowel_irregular', label: '💩 Irregular bowel movements (constipation or diarrhea)' }
        ]
    },

    bloatingTime: {
        id: 'bloatingTime',
        number: 4,
        text: 'When is the bloating usually most noticeable?',
        type: 'radio',
        condition: (answers) => answers.mainIssue?.includes('bloating'),
        options: [
            { value: 'immediately', label: '🍽️ Immediately after meals' },
            { value: '1-2hrs', label: '⏰ 1-2 hours after meals' },
            { value: 'allday', label: '😓 Bloated all day' }
        ]
    },

    appetiteType: {
        id: 'appetiteType',
        number: 4,
        text: 'What is your appetite issue?',
        type: 'radio',
        condition: (answers) => answers.mainIssue?.includes('poor_appetite'),
        options: [
            { value: 'no_appetite', label: '😔 No appetite at all' },
            { value: 'early_fullness', label: '🥄 Full after eating very little' },
            { value: 'greasy_aversion', label: '🤢 No appetite when seeing greasy food' }
        ]
    },

    dietHabits: {
        id: 'dietHabits',
        number: 5,
        text: 'Your eating habits?',
        hint: 'Select all that apply',
        type: 'checkbox',
        options: [
            { value: 'fast_eating', label: '⚡ Eat fast' },
            { value: 'greasy', label: '🍖 Often eat greasy food' },
            { value: 'cold_raw', label: '🧊 Love cold/raw food' },
            { value: 'overeating', label: '🍔 Often binge eat' },
            { value: 'regular', label: '😊 Diet is relatively regular' }
        ]
    },

    bowelMovement: {
        id: 'bowelMovement',
        number: 6,
        text: 'Bowel movement situation?',
        type: 'radio',
        options: [
            { value: 'constipation', label: '💩 Frequent constipation (once every 3+ days)' },
            { value: 'diarrhea', label: '💧 Prone to diarrhea (multiple times a day)' },
            { value: 'alternating', label: '💩💧 Alternating constipation and diarrhea' },
            { value: 'normal', label: '😊 Relatively normal' }
        ]
    },

    otherSymptoms: {
        id: 'otherSymptoms',
        number: 7,
        text: 'Do you have any of these symptoms?',
        hint: 'Select all that apply',
        type: 'checkbox',
        options: [
            { value: 'belching', label: '😮‍💨 Frequent belching (burping)' },
            { value: 'acid_reflux', label: '🔥 Acid reflux, heartburn' },
            { value: 'pain', label: '😣 Abdominal pain, stomach pain' },
            { value: 'nausea', label: '🤢 Nausea, wanting to vomit' },
            { value: 'none', label: 'None of the above', exclusive: true }
        ]
    },

    duration: {
        id: 'duration',
        number: 8,
        text: 'How long have these digestive issues bothered you?',
        type: 'radio',
        options: [
            { value: '<1month', label: '📅 Started within the last month' },
            { value: '1-3months', label: '📅 1-3 months' },
            { value: '>3months', label: '📅 Over 3 months (chronic digestive issues)' }
        ]
    },

    constitution: {
        id: 'constitution',
        number: 9,
        text: 'Do you usually have these conditions?',
        hint: 'Select all that apply',
        type: 'checkbox',
        options: [
            { value: 'cold_limbs', label: '🧊 Cold hands and feet' },
            { value: 'fatigue', label: '😴 Easily fatigued' },
            { value: 'dry_bitter', label: '😝 Dry or bitter mouth' },
            { value: 'thick_coating', label: '👅 Thick tongue coating' },
            { value: 'none', label: 'None of the above', exclusive: true }
        ]
    }
};